import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a Driving Direction icon
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <DrivingDirectionIcon width={12} />
 */

function DrivingDirectionIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M18 20.5C17.8693 20.4984 17.7402 20.4712 17.62 20.42L12 18.08L6.37999 20.42C6.19763 20.497 5.99651 20.5182 5.80211 20.4808C5.60771 20.4434 5.42879 20.3492 5.28799 20.21C5.14661 20.0733 5.0492 19.8975 5.00823 19.7051C4.96726 19.5127 4.98459 19.3125 5.05799 19.13L11.058 4.13C11.1356 3.94392 11.2663 3.78488 11.4339 3.67281C11.6015 3.56074 11.7984 3.50062 12 3.5C12.2003 3.49981 12.396 3.55976 12.5618 3.67208C12.7276 3.78441 12.8559 3.94394 12.93 4.13L18.93 19.13C18.9904 19.2818 19.0128 19.4461 18.9951 19.6085C18.9773 19.7709 18.9201 19.9265 18.8283 20.0616C18.7366 20.1968 18.6131 20.3075 18.4687 20.3839C18.3243 20.4603 18.1634 20.5002 18 20.5Z" />
        </SvgIcon>
    )
}

DrivingDirectionIcon.defaultProps = defaultProps

export { DrivingDirectionIcon }
